import React from 'react';
import { CheckIcon, LockIcon, ZapIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CHECKOUT_URL, GUARANTEE_DAYS, PRICE, REGULAR_PRICE, SAVINGS, STACKED_VALUE } from '../data/offer';
import { volumes } from '../data/volumes';
import { bonuses } from '../data/bonuses';
const badges = [`Save ${SAVINGS}`, 'One-time payment', 'Lifetime access', 'Letter + A4 included'];
export function Pricing() {
  return <section id="pricing" aria-labelledby="pricing-heading" className="w-full bg-cream" data-id="element-181" data-mp="1rsgagn9r8fdf">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-14 sm:py-20" data-id="element-182" data-mp="1rut0zotkvy23">
        <h2 id="pricing-heading" className="font-serif font-bold text-ink text-2xl sm:text-4xl text-center" data-id="element-183" data-mp="25tsouu99o8x7">
          Get the complete system today
        </h2>

        <div className="mt-8 rounded-3xl bg-white border-2 border-sage-soft shadow-card p-6 sm:p-10" data-id="element-184" data-mp="3h638aa24esoz">
          <div className="text-center" data-id="element-185" data-mp="3c7s0s5zasu9x">
            <p className="font-serif font-bold text-ink text-xl sm:text-2xl leading-snug" data-id="element-186" data-mp="3vzgu7ul3lczx">
              Homeschool, Handled. — Complete Kit
            </p>
            <p className="mt-2 text-ink-soft text-sm sm:text-base" data-id="element-187" data-mp="4rkqtmnj7p06">
              Everything that runs the homeschool, minus everything that runs it
              into the ground.
            </p>
          </div>

          <div className="mt-8 grid md:grid-cols-2 gap-x-8 gap-y-6 text-left" data-id="element-188" data-mp="eqk119ny3spa">
            <ul className="space-y-2.5" data-id="element-189" data-mp="3daa4hnlvzl4m">
              {volumes.map(volume => <li key={volume.number} className="flex gap-2.5 text-[15px] text-ink" data-id="element-190" data-mp="3i93l3owgzs90">
                  <CheckIcon className="w-4 h-4 mt-[5px] text-vital shrink-0" aria-hidden="true" data-id="element-191" data-mp="3n5238ur7ge0z" />
                  <span data-id="element-192" data-mp="2uhenpu4skdl7">
                    Volume {Number(volume.number)} — {volume.title}
                    {volume.flag ? ' ★' : ''}
                  </span>
                </li>)}
            </ul>

            <ul className="space-y-2.5" data-id="element-193" data-mp="2rfjuxawiail1">
              {bonuses.map(bonus => <li key={bonus.number} className="flex gap-2.5 text-[15px] text-ink" data-id="element-194" data-mp="2mgqk5q8lt5ok">
                  <span className="mt-[2px] shrink-0" aria-hidden="true" data-id="element-195" data-mp="318qxyp3rxmhy">
                    🎁
                  </span>
                  <span data-id="element-196" data-mp="28i0idxauahtv">
                    Bonus {Number(bonus.number)} — {bonus.title}
                  </span>
                </li>)}
            </ul>
          </div>

          <p className="mt-8 pt-6 border-t border-cream-dark text-center text-sm text-ink-muted" data-id="element-197" data-mp="23la5tjy8u4d7">
            Total value: {STACKED_VALUE} → Regular price:{' '}
            <span className="line-through" data-id="element-198" data-mp="2dgaimmbf88mc">{REGULAR_PRICE}</span>
          </p>

          <div className="mt-3 flex items-end justify-center gap-3" data-id="element-199" data-mp="3tuk51aw3rnaj">
            <span className="font-serif font-black text-6xl sm:text-7xl text-terracotta leading-none" data-id="element-200" data-mp="3ow8vl19pzesu">
              {PRICE}
            </span>
            <span className="text-sm font-semibold text-ink-muted pb-2" data-id="element-201" data-mp="9lzi8fa1c6g">
              USD
            </span>
          </div>

          <ul className="mt-5 flex flex-wrap justify-center gap-2" data-id="element-202" data-mp="5arr22x7atee">
            {badges.map(badge => <li key={badge} className="inline-flex items-center rounded-full bg-cream border border-cream-dark px-3 py-1.5 text-xs font-semibold text-ink-soft" data-id="element-203" data-mp="3nh69ae2i5pil">
                {badge}
              </li>)}
          </ul>

          <p className="mt-5 text-center text-xs text-ink-muted" data-id="element-204" data-mp="nz6k0vr2whhu">
            You&apos;ll be charged in your local currency.
          </p>

          <div className="mt-6 rounded-2xl bg-cream border border-cream-dark p-5 text-[13px] leading-relaxed text-ink-soft" data-id="element-205" data-mp="e9wsbh05d0u9">
            <strong className="text-ink font-semibold" data-id="element-206" data-mp="11zhf6azf8i8t">Please read:</strong>{' '}
            This product is a planning and organization tool for families who
            already homeschool. It is not a curriculum, and it does not provide
            legal, financial, or educational advice. Homeschooling requirements
            vary by location and can change at any time. Nothing in this product
            describes your local requirements or guarantees that you meet them —
            always check your local requirements and adapt these templates to
            fit your situation. You are responsible for how you use this
            material.
          </div>

          <CtaButton href={CHECKOUT_URL} className="mt-6 w-full" data-id="element-207" data-mp="3syx7gpqg2i0d">
            Yes, I want Homeschool, Handled.
          </CtaButton>

          <ul className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs sm:text-sm text-ink-soft font-medium" data-id="element-208" data-mp="3o75cm3099q4f">
            <li className="flex items-center gap-1.5" data-id="element-209" data-mp="3k63j82t0s8ad">
              <LockIcon className="w-4 h-4 text-vital" aria-hidden="true" data-id="element-210" data-mp="kjn8hqhupswt" />
              Secure checkout
            </li>
            <li className="flex items-center gap-1.5" data-id="element-211" data-mp="frc3wac61ixx">
              <ZapIcon className="w-4 h-4 text-vital" aria-hidden="true" data-id="element-212" data-mp="1yf51adnf8m02" />
              Instant download
            </li>
            <li className="flex items-center gap-1.5" data-id="element-213" data-mp="23dq32hibndqm">
              <ShieldCheckIcon className="w-4 h-4 text-vital" aria-hidden="true" data-id="element-214" data-mp="23gc9gdth7n79" />
              {GUARANTEE_DAYS}-day guarantee
            </li>
          </ul>
        </div>
      </div>
    </section>;
}